<template>
    <div class="viewCalls" v-if="job">
        <div class="o-main-content-area o-main-content-area--padBotoomNone">

            <div>
                <div class="callsheet-sticky-header">
                <div class="row c-responsive-fixwidth">
                    <div class="col-md-6">
                        <h1 class="h1">Jobs / Events:<a @click="backToJobDetails">{{" "+ title}}</a></h1>
                    </div>
                </div>

                <div class="c-common-space c-responsive-fixwidth">
                    <div class="col-md-12 o-tab-area o-no-padding">
                        <ul class="o-tab-view o-tab-view--text">
                            <li href="javascript: void(0)" @click="goToViewCalls()"><a class="active">Calls</a></li>
                            <li href="javascript: void(0)" @click="goToPhoneSheet()"><a class="phonesheet-deactive">PhoneSheet</a></li>
                            <li @click="backToJobDetails()"><a href="javascript: void(0)" class="phonesheet-deactive">Job Details</a></li>
                            <li @click="gotoJobAttendance()"><a href="javascript: void(0)" class="phonesheet-deactive">Attendance</a></li>
                            <li @click="loadWishlistSummaryReportJson()"><a href="javascript: void(0)" class="phonesheet-deactive">Wishlist Summary</a></li>
                            <li @click="loadWishlistSummary30DayReportJson()"><a href="javascript: void(0)" class="phonesheet-deactive">WishList 30 Day</a></li>
                        </ul>
                    </div>
                </div>

                <div class="c-common-space c-common-space--overflowVisible clearfix c-responsive-fixwidth">
                    <div class="col-md-12 o-no-padding">
                        <div class="custom-row">
                            <div class="custom-col text-left">
                                <div class="o-viewBy">
                                    <label>View by:</label>
                                    <div class="radio">
                                        <label>
                                            <input type="radio" @change="saveStateEvent" name="o11" value="individual" v-model="callType">
                                            <span class="cr"><i class="cr-icon fa fa-circle"></i></span>
                                            Individual calls
                                        </label>
                                    </div>
                                    <div class="radio">
                                        <label>
                                            <input type="radio" @change="saveStateEvent" name="o11" value="bulk" v-model="callType">
                                            <span class="cr"><i class="cr-icon fa fa-circle"></i></span>
                                            Bulk calls
                                        </label>
                                    </div>
                                </div>
                            </div>
                            <div class="custom-col outer--border text-center" v-if="optionsAllowed">
                                <div class="o-pub">
                                    <label><i class="fa fa-exclamation-triangle" aria-hidden="true"></i> Pub:</label>
                                    <el-switch
                                        style="display: inline"
                                        v-model="selectedJobStatus"
                                        @change="publishedJob"
                                        active-color="#13ce66"
                                        inactive-color="#dcdfe6"
                                        active-value="Published"
                                        inactive-value="Draft"
                                        :disabled="!getPower('silentDelete')">
                                    </el-switch>
                                </div>
                            </div>
                            <div class="custom-col text-center" v-if="optionsAllowed">
                                <div class="o-customSelect o-custom-dropdown o-inline-block">
                                    <label>HTS:</label> 
                                    <span class="o-blue-medium-text">{{job.hts_flag?'Yes':'No'}}</span>
                                </div>
                            </div>

                            <div class="custom-col text-right" v-if="optionsAllowed">
                                <a  href="javascript: void(0)" v-if="getPower('addCall') || addCallPower()" @click="addBulkCall()" class="c-solid-btn c-solid-btn--large c-solid-btn--green"><i class="fa fa-plus" aria-hidden="true"></i> Add Calls</a>
                            </div>                
                        </div>
                    </div>
                </div>
                </div>
                <!-- /Days Filter -->
                <keep-alive>
                    <IndividualCalls :job="job" :sortType="selectedSortType" v-if="callType == 'individual'" v-keep-scroll-position />
                </keep-alive>
                <keep-alive>    
                    <BulkCalls :job="job" :sortType="selectedSortType" v-if="callType == 'bulk'" v-keep-scroll-position />
                </keep-alive>
            </div>
        </div>

        <modal name="bulk-call"  height="auto" :clickToClose="false" :scrollable="true" class="modal-dialog modal-sm">
            <div class="employee-summary" tabindex="-1" role="dialog">
                <div  role="document">
                <!-- .modal-content -->
                <div class="modal-content o-common-modal-content">

                    <!-- .modal-header -->
                    <div class="modal-header u-no-border text-center modal-header--heading">
                    <button @click="closeBulkModal()" type="button" class="close custom-modal--close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button>
                    <h4 class="modal-title">Add Calls</h4>
                    </div>
                    <!-- /.modal-header -->

                    <!-- .modal-body -->
                    <div class="modal-body c-common-box-shadow o-modal-body">
                    <!--modal-Body-fixed -->
                    <div class="bulk-filter">
                            <h2 class="h2 text-center o-modal-link">{{title}}</h2>
                            <div class="c-common-space o-subtitleHeading text-center">
                                <label>Group by: </label>
                                <span>
                                    <div class="checkbox o-custom-radio">
                                        <label>
                                            Position
                                            <input type="checkbox" id="checkbox" @change="onInputchangeCheckbox" v-model="modalFilter.position">
                                            <span class="cr"><i class="cr-icon fa fa-check"></i></span>
                                        </label>
                                    </div>
                                </span>
                                <span>
                                    <div class="checkbox o-custom-radio">
                                        <label>
                                            Start time
                                            <input type="checkbox" id="checkbox" @change="onInputchangeCheckbox" v-model="modalFilter.startTime">
                                            <span class="cr"><i class="cr-icon fa fa-check"></i></span>
                                        </label>
                                    </div>
                                </span>
                                <span>
                                    <div class="checkbox o-custom-radio">
                                        <label>
                                            End time
                                            <input type="checkbox" id="checkbox" @change="onInputchangeCheckbox" v-model="modalFilter.endTime">
                                            <span class="cr"><i class="cr-icon fa fa-check"></i></span>
                                        </label>
                                    </div>
                                </span>
                            </div>
                            <div class="row">
                                <div class="col-sm-12">
                                    <hr class="o-modal-separetor">
                                </div>
                            </div>
                    </div>
                    <!--./modal-Body-fixed -->


                    <!--.modal-Body-Start-End-Position -->
                    <div v-if="modalFilter.position && modalFilter.startTime && modalFilter.endTime" class="add-bulk-form">
                            <div class="c-common-space">
                                <h2 class="h2">All created calls will have the following values:</h2>
                            </div>
                            <div class="row">
                                <div class="col-sm-4">
                                    <div class="form-group">
                                    <label class="common-label-text common-label-text-block">Start Date:</label>
                                    <el-col :span="50">
                                        <el-date-picker
                                        name="date"
                                        class="custom_date"
                                        v-validate="{ required: true}"
                                        v-model="addCall[0].date"
                                        type="date"
                                        :picker-options="pickerOptions"
                                        :format="getDisplayFormat()"
                                        value-format="yyyy-MM-dd"
                                        :placeholder="getDatePlaceholder()">
                                        </el-date-picker>
                                    </el-col>
                                    </div>
                                </div>
                                <div class="col-sm-4">
                                    <div class="form-group">
                                        <label class="common-label-text common-label-text-block">Start time:</label>
                                        <div class="o-custom-dropdown">
                                            <date-picker placeholder="HH:MM AM" name="start" v-validate="{required: true}" v-model="addCall[0].start" :config="config"></date-picker>
                                            <span class="o-custom-drop-time"><i class="fa fa-clock-o" aria-hidden="true"></i></span>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-sm-4">
                                    <div class="form-group">
                                    <label class="common-label-text common-label-text-block">End time</label>
                                    <div class="o-custom-dropdown">
                                        <date-picker placeholder="HH:MM AM" name="end" v-validate="{required: true}" v-model="addCall[0].end" :config="config"></date-picker>
                                        <span class="o-custom-drop-time"><i class="fa fa-clock-o" aria-hidden="true"></i></span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                                <div class="row">
                                <div class="col-sm-4">
                                    <div class="form-group">
                                        <label class="common-label-text common-label-text-block">Position:</label>
                                        <div class="o-cutsomSelect" v-loading="positionLock">
                                            <select v-model="addCall[0].position" class="form-control">
                                                <option v-for="(position,posIdx) in positions" :key="posIdx" :value="position.id">{{position.name}}</option>
                                            </select>
                                        </div>
                                    </div>
                                </div>
                                
                            </div>
                            <div v-for="(addCallData, key) in addCall" :key="key" class="added-row">
                                <div v-if="key != 0" class="add-remove-row-btn text-center">
                                    <a href="javascript: void(0)" @click="removeGroup(key)" class="o-inline-block"><i class="fa fa-minus-circle"></i></a>
                                </div>
                                <hr class="o-modal-separetor">
                                <div class="c-common-space">
                                    <h2 class="h2">Call groups:</h2>
                                </div>
                                <div class="row">
                                    <div class="col-sm-6">
                                        <div class="form-group">
                                            <label class="common-label-text common-label-text-block">Quantity:</label>
                                            <input type="text" v-model="addCallData.quantity" name="quantity" class="form-control" placeholder="">
                                        </div>
                                    </div>
                                    <div class="col-sm-6">
                                        <div class="form-group">
                                            <label class="common-label-text common-label-text-block">Rate(<span v-html="getCurrencyIcon()"></span>):</label>
                                            <input type="text" v-model="addCallData.rate" name="rate" class="form-control" :placeholder="getCurrencyUpper()">
                                        </div>
                                    </div>
                                    <div class="col-sm-12">
                                        <div class="form-group">
                                            <label class="common-label-text common-label-text-block">Notes:</label>
                                            <textarea v-model="addCallData.notes" class="form-control" rows="3" placeholder="Type your notes"></textarea>
                                        </div>
                                    </div>
                                
                                </div>
                            </div>
                            <div class="add-remove-row-btn text-center">
                                <a href="javascript: void(0)" @click="addNewGroup()" class="o-inline-block"><i class="fa fa-plus-circle"></i></a>
                            </div>
                    </div>
                    <!--./modal-body-Start-End-Position -->


                    <!--.modal-Body-Start-End-->
                    <div v-if="!modalFilter.position && modalFilter.startTime && modalFilter.endTime" class="add-bulk-form">
                        <div class="c-common-space">
                            <h2 class="h2">All created calls will have the following values: </h2>
                        </div>
                        <div class="row">
                            <div class="col-sm-4">
                                <div class="form-group">
                                    <label class="common-label-text common-label-text-block">Start Date:</label>
                                    <el-col :span="50">
                                    <el-date-picker
                                        name="date"
                                        class="custom_date"
                                        v-validate="{ required: true}"
                                        v-model="addCall[0].date"
                                        type="date"
                                        value-format="yyyy/MM/dd"
                                        :picker-options="pickerOptions"
                                        :format="getDisplayFormat()"
                                        :placeholder="getDatePlaceholder()">
                                    </el-date-picker>
                                    </el-col>
                                </div>
                            </div>
                            <div class="col-sm-4">
                                <div class="form-group">
                                    <label class="common-label-text common-label-text-block">Start time</label>
                                    <div class="o-custom-dropdown">
                                        <date-picker placeholder="HH:MM AM" name="start" v-validate="{required: true}" v-model="addCall[0].start" :config="config"></date-picker>
                                        <span class="o-custom-drop-time"><i class="fa fa-clock-o" aria-hidden="true"></i></span>
                                    </div>
                                </div>
                            </div>
                            <div class="col-sm-4">
                                <div class="form-group">
                                    <label class="common-label-text common-label-text-block">End time</label>
                                    <div class="o-custom-dropdown">
                                        <date-picker placeholder="HH:MM AM" name="end" v-validate="{required: true}" v-model="addCall[0].end" :config="config"></date-picker>
                                        <span class="o-custom-drop-time"><i class="fa fa-clock-o" aria-hidden="true"></i></span>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div v-for="(addCallData,key) in addCall" :key="key" class="added-row">
                        <div v-if="key != 0" class="add-remove-row-btn text-center">
                            <a href="javascript: void(0)" @click="removeGroup(key)" class="o-inline-block">
                            <i class="fa fa-minus-circle"></i>
                            </a>
                        </div>
                        <hr class="o-modal-separetor">
                        <div class="c-common-space">
                            <h2 class="h2">Call groups:</h2>
                        </div>
                        <div class="row">
                            <div class="col-sm-4">
                                <div class="form-group">
                                    <label class="common-label-text common-label-text-block">Position:</label>
                                    <div class="o-cutsomSelect" v-loading="positionLock">
                                        <select v-model="addCallData.position" class="form-control">
                                            <option v-for="(position,posKey) in positions" :key="posKey" :value="position.id">{{position.name}}</option>
                                        </select>
                                    </div>
                                </div>
                            </div>
                            <div class="col-sm-4">
                                <div class="form-group">
                                    <label class="common-label-text common-label-text-block">Quantity:</label>
                                    <input type="text" v-model="addCallData.quantity" name="quantity" class="form-control" placeholder="">
                                </div>
                            </div>
                            <div class="col-sm-4">
                                        <div class="form-group">
                                            <label class="common-label-text common-label-text-block">Rate(<span v-html="getCurrencyIcon()"></span>):</label>
                                            <input type="text" v-model="addCallData.rate" name="rate" class="form-control" :placeholder="getCurrencyUpper()">
                                        </div>
                                    </div>
                            <div class="col-sm-12">
                                <div class="form-group">
                                    <label class="common-label-text common-label-text-block">Notes:</label>
                                    <textarea v-model="addCallData.notes" class="form-control" rows="3" placeholder="Type your notes"></textarea>
                                </div>
                            </div>
                        </div>
                        </div>
                        <div class="add-remove-row-btn text-center">
                            <a href="javascript: void(0)" @click="addNewGroup()" class="o-inline-block">
                            <i class="fa fa-plus-circle"></i>
                            </a>
                        </div>
                    </div>
                    <!--./modal-body-Start-End -->

                    <!--.modal-Body-Position-->
                    <div v-if="modalFilter.position && !modalFilter.startTime && !  modalFilter.endTime" class="add-bulk-form">
                        <div class="c-common-space">
                            <h2 class="h2">All created calls will have the following values:</h2>
                        </div>
                        <div class="row">
                            <div class="col-sm-4">
                                <div class="form-group">
                                    <label class="common-label-text common-label-text-block">Start Date:</label>
                                    <el-col :span="50">
                                    <el-date-picker
                                        name="date"
                                        class="custom_date"
                                        v-validate="{ required: true}"
                                        v-model="addCall[0].date"
                                        type="date"
                                        :picker-options="pickerOptions"
                                        :format="getDisplayFormat()"
                                        value-format="yyyy-MM-dd"
                                        :placeholder="getDatePlaceholder()">
                                    </el-date-picker>
                                    </el-col>
                                </div>
                            </div>
                            <div class="col-sm-4">
                                <div class="form-group">
                                    <label class="common-label-text common-label-text-block">Position:</label>
                                    <div class="o-cutsomSelect" v-loading="positionLock">
                                        <select v-model="addCall[0].position" class="form-control">
                                        <option v-for="(position,posIdx) in positions" :key="posIdx" :value="position.id">{{position.name}}</option>
                                        </select>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div v-for="(addCallData,key) in addCall" :key="key" class="added-row">
                            <div v-if="key != 0" class="add-remove-row-btn text-center">
                                <a href="javascript: void(0)" @click="removeGroup" class="o-inline-block">
                                    <i class="fa fa-minus-circle"></i>
                                </a>
                            </div>
                            <hr class="o-modal-separetor">
                            <div class="c-common-space">
                                <h2 class="h2">Call groups:</h2>
                            </div>
                            <div class="row">
                                
                                <div class="col-sm-6">
                                    <div class="form-group">
                                        <label class="common-label-text common-label-text-block">Start Time:</label>
                                        <div class="o-custom-dropdown">
                                            <date-picker placeholder="HH:MM AM" name="start" v-validate="{required: true}" v-model="addCallData.start" :config="config"></date-picker>
                                            <span class="o-custom-drop-time"><i class="fa fa-clock-o" aria-hidden="true"></i></span>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-sm-6">
                                        <div class="form-group">
                                            <label class="common-label-text common-label-text-block">End Time:</label>
                                            <div class="o-custom-dropdown">
                                                <date-picker placeholder="HH:MM AM" name="end" v-validate="{required: true}" v-model="addCallData.end" :config="config"></date-picker>
                                                <span class="o-custom-drop-time"><i class="fa fa-clock-o" aria-hidden="true"></i></span>
                                            </div>
                                        </div>
                                </div>
                                <div class="col-sm-6">
                                    <div class="form-group">
                                        <label class="common-label-text common-label-text-block">Quantity:</label>
                                        <input type="text" v-model="addCallData.quantity" name="quantity" class="form-control" placeholder="">
                                    </div>
                                </div>
                                <div class="col-sm-6">
                                        <div class="form-group">
                                            <label class="common-label-text common-label-text-block">Rate(<span v-html="getCurrencyIcon()"></span>):</label>
                                            <input type="text" v-model="addCallData.rate" name="rate" class="form-control" :placeholder="getCurrencyUpper()">
                                        </div>
                                    </div>
                                <div class="col-sm-12">
                                    <div class="form-group">
                                        <label class="common-label-text common-label-text-block">Notes:</label>
                                        <textarea class="form-control" v-model="addCallData.notes" rows="3" placeholder="Type your notes"></textarea>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div @click="addNewGroup()" class="add-remove-row-btn text-center">
                            <a href="javascript: void(0)" class="o-inline-block">
                                <i class="fa fa-plus-circle"></i>
                            </a>
                        </div>
                    </div>
                    <!--./modal-body-Position -->

                    <!--.modal-Body-Position-End-->
                    <div v-if="modalFilter.position && !modalFilter.startTime &&   modalFilter.endTime" class="add-bulk-form">
                        <div class="c-common-space">
                            <h2 class="h2">All created calls will have the following values:</h2>
                        </div>
                        <div class="row">
                            <div class="col-sm-4">
                                <div class="form-group">
                                    <label class="common-label-text common-label-text-block">Start Date:</label>
                                    <el-col :span="50">
                                    <el-date-picker
                                        name="date"
                                        class="custom_date"
                                        v-validate="{ required: true}"
                                        v-model="addCall[0].date"
                                        type="date"
                                        :picker-options="pickerOptions"
                                        :format="getDisplayFormat()"
                                        value-format="yyyy-MM-dd"
                                        :placeholder="getDatePlaceholder()">
                                    </el-date-picker>
                                    </el-col>
                                </div>
                            </div>
                            <div class="col-sm-4">
                                <div class="form-group">
                                    <label class="common-label-text common-label-text-block">Start Time:</label>
                                    <div class="o-custom-dropdown">
                                        <date-picker placeholder="HH:MM AM" name="start" v-validate="{required: true}" v-model="addCall[0].start" :config="config"></date-picker>
                                        <span class="o-custom-drop-time"><i class="fa fa-clock-o" aria-hidden="true"></i></span>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div v-for="(addCallData,key) in addCall" :key="key" class="added-row">
                            <div v-if="key != 0" class="add-remove-row-btn text-center">
                                <a href="javascript: void(0)" @click="removeGroup(key)" class="o-inline-block">
                                    <i class="fa fa-minus-circle"></i>
                                </a>
                            </div>
                            <hr class="o-modal-separetor">
                            <div class="c-common-space">
                                <h2 class="h2">Call groups:</h2>
                            </div>
                            <div class="row">
                                <div class="col-sm-6">
                                <div class="form-group">
                                    <label class="common-label-text common-label-text-block">Position:</label>
                                    <div class="o-cutsomSelect" v-loading="positionLock">
                                    <select v-model="addCallData.position" class="form-control">
                                        <option v-for="(position,posKey) in positions" :key="posKey" :value="position.id">{{position.name}}</option>
                                    </select>
                                    </div>
                                </div>
                                </div>
                                <div class="col-sm-6">
                                    <div class="form-group">
                                        <label class="common-label-text common-label-text-block">End Time:</label>
                                        <div class="o-custom-dropdown">
                                            <date-picker placeholder="HH:MM AM" name="end" v-validate="{required: true}" v-model="addCallData.end" :config="config"></date-picker>
                                            <span class="o-custom-drop-time"><i class="fa fa-clock-o" aria-hidden="true"></i></span>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-sm-6">
                                    <div class="form-group">
                                        <label class="common-label-text common-label-text-block">Quantity:</label>
                                        <input type="text" v-model="addCallData.quantity" name="quantity" class="form-control" placeholder="">
                                    </div>
                                </div>
                                <div class="col-sm-6">
                                        <div class="form-group">
                                            <label class="common-label-text common-label-text-block">Rate(<span v-html="getCurrencyIcon()"></span>):</label>
                                            <input type="text" v-model="addCallData.rate" name="rate" class="form-control" :placeholder="getCurrencyUpper()">
                                        </div>
                                    </div>
                                <div class="col-sm-12">
                                    <div class="form-group">
                                        <label class="common-label-text common-label-text-block">Notes:</label>
                                        <textarea v-model="addCallData.notes" class="form-control" rows="3" placeholder="Type your notes"></textarea>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="add-remove-row-btn text-center">
                            <a href="javascript: void(0)" @click="addNewGroup()" class="o-inline-block">
                                <i class="fa fa-plus-circle"></i>
                            </a>
                        </div>
                    </div>
                    <!--./modal-body-Position-End -->

                    <!--.modal-Body-Position-Start-->
                    <div v-if="modalFilter.position && modalFilter.startTime &&   !modalFilter.endTime" class="add-bulk-form">
                        <div class="c-common-space">
                            <h2 class="h2">All created calls will have the following values:</h2>
                        </div>
                        <div class="row">
                            <div class="col-sm-4">
                                <div class="form-group">
                                    <label class="common-label-text common-label-text-block">Start Date</label>
                                    <el-col :span="50">
                                    <el-date-picker
                                        name="date"
                                        class="custom_date"
                                        v-validate="{ required: true}"
                                        v-model="addCall[0].date"
                                        type="date"
                                        :picker-options="pickerOptions"
                                        :format="getDisplayFormat()"
                                        value-format="yyyy-MM-dd"
                                        :placeholder="getDatePlaceholder()">
                                    </el-date-picker>
                                    </el-col>
                                </div>
                            </div>
                            <div class="col-sm-4">
                                <div class="form-group">
                                    <label class="common-label-text common-label-text-block">End Time:</label>
                                    <div class="o-custom-dropdown">
                                        <date-picker placeholder="HH:MM AM" name="end" v-validate="{required: true}" v-model="addCall[0].end" :config="config"></date-picker>
                                        <span class="o-custom-drop-time"><i class="fa fa-clock-o" aria-hidden="true"></i></span>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div v-for="(addCallData,key) in addCall" :key="key" class="added-row">
                            <div v-if="key != 0" class="add-remove-row-btn text-center">
                                <a href="javascript: void(0)" @click="removeGroup(key)" class="o-inline-block"><i class="fa fa-minus-circle"></i></a>
                            </div>
                            <hr class="o-modal-separetor">
                            <div class="c-common-space">
                                <h2 class="h2">Call groups:</h2>
                            </div>
                            
                            <div class="row">
                                <div class="col-sm-6">
                                    <div class="form-group">
                                        <label class="common-label-text common-label-text-block">Start Time:</label>
                                        <div class="o-custom-dropdown">
                                            <date-picker placeholder="HH:MM AM" name="Start" v-validate="{required: true}" v-model="addCallData.Start" :config="config"></date-picker>
                                            <span class="o-custom-drop-time"><i class="fa fa-clock-o" aria-hidden="true"></i></span>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-sm-6">
                                <div class="form-group">
                                    <label class="common-label-text common-label-text-block">Position:</label>
                                    <div class="o-cutsomSelect"  v-loading="positionLock">
                                    <select v-model="addCallData.position" class="form-control">
                                        <option v-for="(position,posKey) in positions" :key="posKey" :value="position.id">{{position.name}}</option>
                                    </select>
                                    </div>
                                </div>
                            </div>
                                <div class="col-sm-6">
                                    <div class="form-group">
                                        <label class="common-label-text common-label-text-block">Quantity:</label>
                                        
                                        <input type="text" v-model="addCallData.quantity" name="quantity" class="form-control" placeholder="">
                                    </div>
                                </div>
                                <div class="col-sm-6">
                                        <div class="form-group">
                                            <label class="common-label-text common-label-text-block">Rate(<span v-html="getCurrencyIcon()"></span>):</label>
                                            <input type="text" v-model="addCallData.rate" name="rate" class="form-control" :placeholder="getCurrencyUpper()">
                                        </div>
                                    </div>
                                <div class="col-sm-12">
                                    <div class="form-group">
                                        <label class="common-label-text common-label-text-block">Notes:</label>
                                        <textarea v-model="addCallData.notes" class="form-control" rows="3" placeholder="Type your notes"></textarea>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="add-remove-row-btn text-center">
                            <a href="javascript: void(0)" @click="addNewGroup()" class="o-inline-block"><i class="fa fa-plus-circle"></i></a>
                        </div>
                    </div>
                    <!--./modal-body-Position-Start -->

                    <!--.modal-Body-Start-->
                    <div v-if="!modalFilter.position && modalFilter.startTime &&   !modalFilter.endTime" class="add-bulk-form">
                        <div class="c-common-space">
                            <h2 class="h2">All created calls will have the following values:</h2>
                        </div>
                        <div class="row">  
                            <div class="col-sm-4">
                                <div class="form-group">
                                    <label class="common-label-text common-label-text-block">Start Date</label>
                                    <el-date-picker
                                        name="date"
                                        class="custom_date"
                                        v-validate="{ required: true}"
                                        v-model="addCall[0].date"
                                        type="date"
                                        :picker-options="pickerOptions"
                                        :format="getDisplayFormat()"
                                        value-format="yyyy-MM-dd"
                                        :placeholder="getDatePlaceholder()">
                                    </el-date-picker>
                                </div>
                            </div>
                            <div class="col-sm-4">
                                <div class="form-group">
                                    <label class="common-label-text common-label-text-block">End Time:</label>
                                    <div class="o-custom-dropdown">
                                        <date-picker placeholder="HH:MM AM" name="end" v-validate="{required: true}" v-model="addCall[0].end" :config="config"></date-picker>
                                        <span class="o-custom-drop-time"><i class="fa fa-clock-o" aria-hidden="true"></i></span>
                                    </div>
                                </div>
                            </div>
                            <div class="col-sm-4">
                                <div class="form-group">
                                    <label class="common-label-text common-label-text-block">Position:</label>
                                    <div class="o-cutsomSelect"  v-loading="positionLock">
                                        <select v-model="addCall[0].position" class="form-control">
                                        <option v-for="(position,posIdx) in positions" :key="posIdx" :value="position.id">{{position.name}}</option>
                                        </select>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div v-for="(addCallData,key) in addCall" :key="key" class="added-row">
                            <div v-if="key != 0" class="add-remove-row-btn text-center">
                                <a href="javascript: void(0)" @click="removeGroup(key)" class="o-inline-block"><i class="fa fa-minus-circle"></i></a>
                            </div>
                            <hr class="o-modal-separetor">
                            <div class="c-common-space">
                                <h2 class="h2">Call groups:</h2>
                            </div>
                            <div class="row">
                                <div class="col-sm-4">
                                    <div class="form-group">
                                        <label class="common-label-text common-label-text-block">Quantity:</label>
                                        
                                        <input type="text" v-model="addCallData.quantity" name="quantity" class="form-control" placeholder="">
                                    </div>
                                </div>
                                <div class="col-sm-4">
                                        <div class="form-group">
                                            <label class="common-label-text common-label-text-block">Rate(<span v-html="getCurrencyIcon()"></span>):</label>
                                            <input type="text" v-model="addCallData.rate" name="rate" class="form-control" :placeholder="getCurrencyUpper()">
                                        </div>
                                </div>
                                <div class="col-sm-4">
                                    <div class="form-group">
                                        <label class="common-label-text common-label-text-block">Start Time:</label>
                                        <div class="o-custom-dropdown">
                                            <date-picker placeholder="HH:MM AM" name="Start" v-validate="{required: true}" v-model="addCallData.start" :config="config"></date-picker>
                                            <span class="o-custom-drop-time"><i class="fa fa-clock-o" aria-hidden="true"></i></span>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-sm-12">
                                    <div class="form-group">
                                        <label class="common-label-text common-label-text-block">Notes:</label>
                                        <textarea v-model="addCallData.notes" class="form-control" rows="3" placeholder="Type your notes"></textarea>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="add-remove-row-btn text-center">
                            <a href="javascript: void(0)" @click="addNewGroup()" class="o-inline-block"><i class="fa fa-plus-circle"></i></a>
                        </div>
                    </div>
                    <!--./modal-body-Start -->

                    <!--.modal-Body-End-->
                    <div v-if="!modalFilter.position && !modalFilter.startTime && modalFilter.endTime" class="add-bulk-form">
                        <div class="c-common-space">
                            <h2 class="h2">All created calls will have the following values:</h2>
                        </div>
                        <div class="row">
                            <div class="col-sm-4">
                                <div class="form-group">
                                    <label class="common-label-text common-label-text-block">Start Date</label>
                                    <el-date-picker
                                        name="date"
                                        class="custom_date"
                                        v-validate="{ required: true}"
                                        v-model="addCall[0].date"
                                        type="date"
                                        :picker-options="pickerOptions"
                                        :format="getDisplayFormat()"
                                        value-format="yyyy-MM-dd"
                                        :placeholder="getDatePlaceholder()">
                                    </el-date-picker>
                                </div>
                            </div>
                            <div class="col-sm-4">
                                <div class="form-group">
                                    <label class="common-label-text common-label-text-block">Start Time:</label>
                                    <div class="o-custom-dropdown">
                                        <date-picker placeholder="HH:MM AM" name="end" v-validate="{required: true}" v-model="addCall[0].start" :config="config"></date-picker>
                                        <span class="o-custom-drop-time"><i class="fa fa-clock-o" aria-hidden="true"></i></span>
                                    </div>
                                </div>
                            </div>
                            <div class="col-sm-4">
                                <div class="form-group">
                                    <label class="common-label-text common-label-text-block">Position:</label>
                                    <div class="o-cutsomSelect"  v-loading="positionLock">
                                        <select v-model="addCall[0].position" class="form-control">
                                        <option v-for="(position,posKey) in positions" :key="posKey" :value="position.id">{{position.name}}</option>
                                        </select>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div v-for="(addCallData,key) in addCall" :key="key" class="added-row">
                            <div v-if="key != 0" class="add-remove-row-btn text-center">
                                <a href="javascript: void(0)" @click="removeGroup(key)" class="o-inline-block"><i class="fa fa-minus-circle"></i></a>

                            </div>
                            <hr class="o-modal-separetor">
                            <div class="c-common-space">
                                <h2 class="h2">Call groups:</h2>
                            </div>
                            <div class="row">
                                <div class="col-sm-4">
                                    <div class="form-group">
                                        <label class="common-label-text common-label-text-block">Quantity:</label>
                                        
                                        <input type="text" v-model="addCallData.quantity" name="quantity" class="form-control" placeholder="">
                                    </div>
                                </div>
                                <div class="col-sm-4">
                                        <div class="form-group">
                                            <label class="common-label-text common-label-text-block">Rate(<span v-html="getCurrencyIcon()"></span>):</label>
                                            <input type="text" v-model="addCallData.rate" name="rate" class="form-control" :placeholder="getCurrencyUpper()">
                                        </div>
                                </div>
                                <div class="col-sm-4">
                                    <div class="form-group">
                                        <label class="common-label-text common-label-text-block">End Time:</label>
                                        <div class="o-custom-dropdown">
                                            <date-picker placeholder="HH:MM AM" name="end" v-validate="{required: true}" v-model="addCallData.end" :config="config"></date-picker>
                                            <span class="o-custom-drop-time"><i class="fa fa-clock-o" aria-hidden="true"></i></span>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-sm-12">
                                    <div class="form-group">
                                        <label class="common-label-text common-label-text-block">Notes:</label>
                                        <textarea v-model="addCallData.notes" class="form-control" rows="" placeholder="Type your notes"></textarea>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="add-remove-row-btn text-center">
                            <a href="javascript: void(0)" @click="addNewGroup()" class="o-inline-block"><i class="fa fa-plus-circle"></i></a>
                        </div>
                    </div>
                    <!--./modal-body-End -->
                    </div>
                    <!-- /.modal-body -->

                    <!-- .modal-footer -->
                    <div class="modal-footer text-center">
                            <ul class="o-filter-area">
                                <li>
                                    <a href="javascript: void(0)" @click="closeBulkModal()" data-dismiss="modal" aria-label="Close" class="c-common-btn c-common-btn--large c-common-btn--inverse-icon-blue"><i class="fa fa-minus-circle" aria-hidden="true"></i> Cancel</a>
                                </li>
                                <li>
                                    <a href="javascript: void(0)" @click="saveBulkCall()" class="c-common-btn c-common-btn--large c-common-btn--green"><i class="fa fa-plus" aria-hidden="true"></i> Add Calls</a>
                                </li>
                            </ul>
                    </div>
                    <!-- /.modal-footer -->

                </div>
                <!-- /.modal-content -->
                </div>

            </div>
        </modal>
    </div>
    <div v-else-if="!isEmployeeAllowed">
        <NotAllowed />
    </div>
</template>
<script>
    import BulkCalls from './bulkCalls';
    import dateTimeConvert from '../../timeConvert&Compare';
    import IndividualCalls from './individualCallSplit';
    import NotAllowed from '@/components/NotAllowed';
    import { mapGetters } from 'vuex';
    import { bus } from '../../main';
    import service from '../../services.js';
    import { scroller } from 'vue-scrollto/src/scrollTo';

    export default {
        components: {
            'IndividualCalls': IndividualCalls,
            'BulkCalls': BulkCalls,
            'NotAllowed': NotAllowed
        },
        computed: {
            ...mapGetters({
                userToken: 'userToken',
                userRole: 'userRole',
                userID: 'userID',
                userFullName: 'userFullName',
                userClientID: 'userClientID',
                employeeId: 'employeeId',
                getSelectedCallList: 'getSelectedCallList',
                getLastPositionId: 'getLastPositionId',
                getCurrency: 'getCurrency',
            })
        },
        data() {
            const dataProps = {
                optionsAllowed: true,
                isEmployeeAllowed: true,
                rdlxWishlistUrl: null,
                positionLock:false,
                jobStart: null,
                jobEnd: null,
                jobEmployeeId:'',//job steward employee id.
                job: null,
                selectedJobStatus: '',
                selectedSortType: 'skill',
                title: "",
                calls: [],
                config: {
                    format: 'h:mm A',
                    useCurrent: false,
                    showClear: false,
                    showClose: false,
                    widgetPositioning: {
                        horizontal: 'right'
                    },
                    parseInputDate: (inputDate) => {
                        if (typeof inputDate === 'string') {
                        const match = inputDate.match(/^(\d{1,2})(\d{2})?$/);

                        if (match) {
                            let hours = parseInt(match[1], 10);
                            let minutes = match[2] ? parseInt(match[2], 10) : 0;
                            return moment({ hour: hours, minute: minutes });
                        }
                        }
                        return moment(inputDate, 'hh:mm A');
                    }
                },
                addCall: [{
                    date: '',
                    start: '',
                    end: '',
                    quantity: '',
                    rate: '',
                    position: '',
                    notes: ''
                }],
                modalFilter: {
                    position: false,
                    startTime: true,
                    endTime: true
                },
                callType: "bulk",
                validation_err: 0,
                positions: [],
                pickerOptions: {
                    disabledDate(time) {
                        return (time.getTime() < dataProps.getDates().jobStart || time.getTime() > dataProps.getDates().jobEnd);
                    }
                },
                getDates: function() {
                    return {
                        jobStart: dataProps.jobStart,
                        jobEnd: dataProps.jobEnd
                    };
                }
            }

            return dataProps;
        },
        methods: {
            getCurrencyIcon(){
                let icon='';
                switch(this.getCurrency){
                    case 'usd':
                        icon = '$';
                        break;
                    case 'pound':
                        icon = '&#163;';
                        break;
                    default:
                        icon = '$';
                }
                return icon;
            },
            
            getCurrencyUpper(){
                return this.getCurrency?this.getCurrency.toUpperCase():'USD';
            },

            getDisplayFormat(){
                var format = dateTimeConvert.getDateInputFormat();
                return format?format:'MM/dd/yyyy';
            },

            getDatePlaceholder(){
                return dateTimeConvert.getDatePlaceHolder();
            },

            addCallPower(){
                if(this.jobEmployeeId==this.employeeId){
                  return true;
                }else{
                  return false;
                }                
            },

            getDate(str) {
                return dateTimeConvert.localDate(str);
            },

            getDateScrollTO(str) {
                return moment(str, 'YYYY-MM-DD').format('DD MMM YYYY');
            },

            getPower(data) {
                return dateTimeConvert.checkAccess(data);
            },

            backToJobDetails(){
                this.$router.push({
                    path: `/jobDetails/`+this.$route.params.jobId
                });
            },

            gotoJobAttendance() {
                this.$router.push({
                    path: `/jobAttendance/`+this.$route.params.jobId
                });
            },

            saveStateEvent() {
                this.$store.dispatch('setSelectedCallList', this.callType);
            },

            onSelectScrollTo(e) {
                const firstScrollTo = scroller();
                firstScrollTo(e.target.value, 200, {
                    offset: -100
                });
            },

            goToViewCalls() {
                this.$router.push({
                    path: '/viewCalls'
                });
            },

            publishedJob() {
                var job = this.job;
                this.$Progress.start();
                var hiring_organization = ''; //job.hiring_organization ? job.hiring_organization.id : "";
                var venue = ''; // job.venue ? venue.id : "";
                let body = {
                    'noteable_id': job.id,
                    'noteable_type': 'job',
                    'activity': JSON.stringify({
                        'uploader_id': this.userID,
                        'uploaded_by': this.userFullName
                    }),
                    'content': this.selectedJobStatus=='Published'?'Publish Job':'Unpublish Job',
                    'hiring_organization': '',
                    'venue': '',
                };
                if (this.selectedJobStatus == "Published") {
                    service.put('job/' + job.id + '/publish', body, {
                        'Authorization': this.userToken,
                        'cs3-context-role': this.userRole,
                        'cs3-context-clientId': this.userClientID
                    }).
                    then((res) => {
                        this.$Progress.finish();
                        job.status.name = this.selectedJobStatus;
                        this.$notify.success({
                            message: res.data.status_message,
                            title: 'Success'
                        });
                    }).catch((err) => {
                        console.log(err);
                    });
                } else {
                    service.put('job/' + job.id + '/unpublish', body, {
                        'Authorization': this.userToken,
                        'cs3-context-role': this.userRole,
                        'cs3-context-clientId': this.userClientID
                    }).
                    then((res) => {
                        this.$Progress.finish();
                        job.status.name = this.selectedJobStatus;
                        this.$notify.success({
                            message: res.data.status_message,
                            title: 'Success'
                        });
                    }).catch((err) => {
                        console.log(err);
                    });
                }
            },

            goToPhoneSheet() {
                this.$router.push({
                    path: '/phoneSheet/' + this.$route.params.jobId
                });
            },

            saveBulkCall() {
                let callData = this.addCall.map(call => {
                    let data = {
                        "end": call.date + " " + dateTimeConvert.convertTo24Hours(call.end),
                        "job_id": this.job.id,
                        "quantity": call.quantity,
                        "rate": call.rate,
                        "skill_id": call.position,
                        "start": call.date + " " + dateTimeConvert.convertTo24Hours(call.start),
                        "called_at": call.date + " " + dateTimeConvert.convertTo24Hours(call.start),
                        "notes": call.notes
                    };
                    return data;
                });
                callData = JSON.stringify(callData);
                service.post('call/storeBulkCall', {
                        'call_array': callData
                    }, {
                        'Authorization': this.userToken,
                        'cs3-context-role': this.userRole,
                        'cs3-context-clientId': this.userClientID
                    })
                    .then((res) => {
                        this.$modal.hide("add-call");
                        this.$notify({
                            title: this.$t('success'),
                            message: 'Call Added Successfully.',
                            type: 'success'
                        });
                        bus.$emit('onSaveNewCall', 'new Call Added');
                        this.$modal.hide("bulk-call");
                    }).catch((err) => {
                        console.log(err);
                    });
            },

            addBulkCall() {
                this.$router.push({
					path:'/addCall/'+ this.$route.params.jobId
				});
            },

            closeBulkModal() {
                this.$modal.hide("bulk-call");
            },

            addNewGroup() {
                var temp = {
                    date: this.addCall[0].date,
                    start: this.addCall[0].start,
                    end: this.addCall[0].end,
                    quantity: '',
                    rate: this.addCall[0].rate,
                    position: this.addCall[0].position,
                    notes: ''
                };
                this.addCall.push(temp);
            },

            removeGroup(key) {
                this.addCall.splice(key, 1);
            },

            onInputchangeCheckbox() {
                this.addCall = [{
                    date: '',
                    start: '',
                    end: '',
                    quantity: '',
                    rate: '',
                    position: '',
                    notes: ''
                }];

                let getStartDate = this.job.start.split(" ");
                this.addCall[0].date = getStartDate[0];
            },

            getSkill() {
                this.positionLock=true;
                service.get('skill/getAllSkills', {
                    'Authorization': this.userToken,
                    'cs3-context-clientId': this.userClientID
                }).
                then((res) => {
                    this.positions = res.data.result;
                    this.positionLock=false;
                }).catch((err) => {
                    console.log(err);
                    this.positionLock=false;
                });

            },

            async jobDetails() {
                this.$Progress.start();
                await service.get('job/' + atob(this.$route.params.jobId), {
                    'Authorization': this.userToken,
                    'cs3-context-role': this.userRole,
                    'cs3-context-clientId': this.userClientID
                }).
                then((res) => {
                    this.job=res.data.result;
                    this.$store.dispatch('saveJobDetails', res.data.result);
                    this.selectedJobStatus = (this.job.status)?this.job.status.name:'Draft';
                    this.title = this.job.title;
                    this.jobStart = new Date(this.job.start);
                    this.jobStart.setDate(this.jobStart.getDate() - 1);

                    this.jobEnd = new Date(this.job.end);
                    this.jobEmployeeId= this.job.employee ? this.job.employee.id : '';
                    this.$Progress.finish();
                }).catch((err) => {
                    console.log(err);
                    if(err.response&&err.response.status&&err.response.status==403) {
                        this.isEmployeeAllowed = false;
                        this.$notify({
                            title: 'Important message',
                            message: "You don't have Access!",
                            type: 'error'
                        });
                        this.$router.push({path: '/schedule/', params: {empId: btoa(this.employeeId)}});
                    }
                });
            },
            
            getClient(){
                service.get('client/' + this.userClientID, {
                    'Authorization': this.userToken
                }).
                then((res) => {
                    this.selectedSortType=res.data.result.default_call_sort;
                    this.$store.dispatch('saveClientDetails', res.data.result);
                }).catch((err) => {
                    console.log(err);
                });        
            },

            getEmployeeStatus(){
                service.get('employee/employee_status_lite', {
                    'Authorization': this.userToken,
                    'cs3-context-role': this.userRole,
                    'cs3-context-clientId': this.userClientID
                }).
                then((res) => {
                    let statusList = res.data.result;
                    statusList.sort(function(a, b) {
                        if (Number(a.priority) < Number(b.priority)) return -1;
                        if (Number(a.priority) > Number(b.priority)) return 1;
                        return 0;
                    });
                    this.$store.dispatch('saveStatusList', statusList);
                }).catch((err) => {
                    console.log(err);
                });
            },

            async getWishlistSummary30DayReportTemplateUrl() {
                // Prefer the dedicated 30-day template; fall back to the job
                // wishlist template if a 30-day one has not been uploaded yet.
                await service.get('client/getEmployeeWishlistSummary30DayReportUrl', {
                    'Authorization': this.userToken,
                    'cs3-context-role': this.userRole,
                    'cs3-context-clientId': this.userClientID,
                })
                .then((res) => {
                    if (res.data && res.data.result && res.data.result != '') {
                        this.rdlxWishlistUrl = res.data.result;
                    }
                }).catch((err) => {
                    console.log(err);
                });
                if (!this.rdlxWishlistUrl) {
                    await service.get('client/getEmployeeWishlistSummaryReportUrl', {
                        'Authorization': this.userToken,
                        'cs3-context-role': this.userRole,
                        'cs3-context-clientId': this.userClientID,
                    })
                    .then((res) => {
                        if (res.data && res.data.result && res.data.result != '') {
                            this.rdlxWishlistUrl = res.data.result;
                        }
                    }).catch((err) => {
                        console.log(err);
                    });
                }
            },

            // #1561: this loader pulls the 30-DAY payload — renamed to match its
            // "WishList 30 Day" button. The plain "Wishlist Summary" loader is below.
            loadWishlistSummary30DayReportJson() {
                this.loading = true;
                service.get('client/employeeWishlistSummary30DayJsonPayload', {
                    'Authorization': this.userToken,
                    'cs3-context-role': this.userRole,
                    'cs3-context-clientId': this.userClientID
                })
                .then(async (res) => {
                    await this.getWishlistSummary30DayReportTemplateUrl();
                    this.loading = false;
                    let data_source = res.data.result && res.data.result != '' ? res.data.result : null;
                    if (this.rdlxWishlistUrl && data_source) {
                        let redirectUrl = dateTimeConvert.getEmployeeReportUrl('jobReports/', this.rdlxWishlistUrl, data_source);
                        let wishlistPopup = window.open(redirectUrl, 'wishlistSummaryPopup', 'width=1200,height=800,scrollbars=yes,resizable=yes');
                        if (!wishlistPopup) {
                            // popup blocked — fall back to a new tab
                            window.open(redirectUrl, "_blank");
                        }
                    } else {
                        this.$notify({
                            title: 'Error',
                            message: 'Something went wrong!',
                            type: 'error'
                        });
                    }
                }).catch((err) => {
                    this.loading = false;
                    console.log(err);
                });
            },

            // #1561: plain Wishlist Summary — mirrors the 30-day loader above but hits the
            // plain endpoints. NOTE employeeWishlistSummaryJsonPayload takes the job uuid as
            // a PATH param (unlike the 30-day endpoint, which is header-scoped).
            async getWishlistSummaryReportTemplateUrl() {
                await service.get('client/getEmployeeWishlistSummaryReportUrl', {
                    'Authorization': this.userToken,
                    'cs3-context-role': this.userRole,
                    'cs3-context-clientId': this.userClientID,
                })
                .then((res) => {
                    if (res.data && res.data.result && res.data.result != '') {
                        this.rdlxWishlistUrl = res.data.result;
                    }
                }).catch((err) => {
                    console.log(err);
                });
            },

            loadWishlistSummaryReportJson() {
                this.loading = true;
                service.get('client/employeeWishlistSummaryJsonPayload/' + atob(this.$route.params.jobId), {
                    'Authorization': this.userToken,
                    'cs3-context-role': this.userRole,
                    'cs3-context-clientId': this.userClientID
                })
                .then(async (res) => {
                    await this.getWishlistSummaryReportTemplateUrl();
                    this.loading = false;
                    let data_source = res.data.result && res.data.result != '' ? res.data.result : null;
                    if (this.rdlxWishlistUrl && data_source) {
                        let redirectUrl = dateTimeConvert.getEmployeeReportUrl('jobReports/', this.rdlxWishlistUrl, data_source);
                        let wishlistPopup = window.open(redirectUrl, 'wishlistSummaryPopup', 'width=1200,height=800,scrollbars=yes,resizable=yes');
                        if (!wishlistPopup) {
                            // popup blocked — fall back to a new tab
                            window.open(redirectUrl, "_blank");
                        }
                    } else {
                        this.$notify({
                            title: 'Error',
                            message: 'Something went wrong!',
                            type: 'error'
                        });
                    }
                }).catch((err) => {
                    this.loading = false;
                    console.log(err);
                });
            }
        },
        async created() {
            this.callType = (this.getSelectedCallList) ? this.getSelectedCallList : "individual";
            await this.jobDetails();
            if(this.job) {
                this.getClient();
                this.getEmployeeStatus();
                this.jobStart = new Date(this.job.start);
                this.jobStart.setDate(this.jobStart.getDate() - 1);
                this.jobEnd = new Date(this.job.end);
                document.title = `${this.job.job_number}#${this.job.title}`;
            }
            bus.$on('onUpdateCallList', (data) => {
                this.calls = data;
            });

            bus.$on('onOptionsNotAllowed', (data) => {
                this.optionsAllowed = data 
            });

            bus.$on('sortTypeChanged', (sort_type) => {
                this.selectedSortType = sort_type;
            })
        },
        mounted() {
            $(this.$el).find('input').datetimepicker(this.config)
            .on('dp.show', (e) => {
                const picker = e.target; // Reference to the picker element
                const currentTime = moment();
                if (!picker.value) {
                    $(picker).data('DateTimePicker').date(currentTime);
                }
            });
        }
    }

</script>
<style scoped>
    a:hover {
        cursor: pointer;
    }

    .v--modal-overlay.scrollable {
        margin-top: 0;
        padding-top: 30px;
    }
    .phonesheet-deactive{
          background-color: #ffffff;
          border-radius: 5px;
          border: 1px solid #bfbdbd;
    }
    /* #1336 — lock the Call Sheet header (tabs + view-by/pub/HTS/Add Calls)
       so the call list scrolls underneath. top:93px clears the fixed .o-header
       (matches .o-main-content-area padding-top). */
    .callsheet-sticky-header {
          position: -webkit-sticky;
          position: sticky;
          top: 93px;
          z-index: 5;
          background-color: #F4F7F8;
    }
</style>
